<template>
  <CustomTable ref="table" class="business-table" :elements=elements :data="data" :loadData="loadData">
    <template v-slot:header-options>
      <button @click="$refs.addBusinessModal.openModal()" class="action-button" type="button"><span class="fas fa-plus"></span>Nouveau devis</button>
    </template>
    <template v-slot:table>
      <thead>
      <tr>
        <custom-header field="number" class="hide-for-mobile col-fit">Devis</custom-header>
        <custom-header field="invoiceNumber" class="hide-for-mobile col-fit">Facture</custom-header>
        <custom-header field="title" class="hide-for-mobile col-fill">Titre</custom-header>
        <custom-header field="status" class="hide-for-mobile col-fit">Status</custom-header>
        <custom-header field="ttcAmount" class="hide-for-mobile col-fit">Montant</custom-header>
        <custom-header class="col-fit" field="remaining">Solde</custom-header>
      </tr>
      </thead>
      <tbody v-if="data && data.length > 0">
      <tr v-for="(business, index) in $refs.table.$refs.searchArray.simpleFilter(data)" :key="index" class="business-row" @click="openBusiness(business)">
        <!--<td class="only-desktop-table-cell" style="max-width: 68px">{{ business.createdAt ? (new Date(business.createdAt)).toLocaleDateString("en-GB", formattedDateTime) : '-'}}</td>-->
        <custom-body field="number" class="hide-for-mobile col-fit">
          <QuoteNumber :number="business.number" />
        </custom-body>
        <custom-body field="invoiceNumber" class="hide-for-mobile col-fit">
          <DocumentChips :invoice-number="showInvoice(business) ? business.invoiceNumber : undefined" />
        </custom-body>
        <custom-body field="title" class="hide-for-mobile col-fill" :title="business.title">{{ business.title ? business.title : ''}}</custom-body>
        <custom-body field="status" class="hide-for-mobile col-fit"><StatusBadge :status="business.status" /></custom-body>
        <custom-body field="ttcAmount" class="hide-for-mobile col-fit cell-strong">{{ business.ttcAmount ? business.ttcAmount.toLocaleString('fr-FR') + ' €' : ''}}</custom-body>
        <custom-body class="col-fit" field="remaining">{{business.remaining && business.invoiceNumber ? business.remaining.toLocaleString('fr-FR')  + ' €' : ''}}</custom-body>
      </tr>
      </tbody>
      <tbody v-else><tr class="empty-row"><td colspan="7">Aucun contrat enregistré</td></tr></tbody>
    </template>
  </CustomTable>
  <BusinessManagementModal ref="businessManagementModal" :callback=loadData />
  <AddBusinessModal ref="addBusinessModal" :callback=openCreatedBusiness />
</template>

<script>
import AddBusinessModal from "@/components/modals/AddBusinessModal.vue";
import {BusinessController} from "@/controllers/business/BusinessController";
import BusinessManagementModal from "@/components/modals/BusinessManagementModal.vue";
import {BUSINESS_STATUS_ENUM as BusinessStatusEnum, BUSINESS_STATUS_ENUM} from "@/models/businessStatusEnum";
import CustomTable from "@/components/CustomTable.vue";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMoneyBillTransfer, faList, faChevronLeft, faChevronRight, faPlus, faFilePen, faFileLines, faFilePdf, faDownload } from "@fortawesome/free-solid-svg-icons";
import CustomHeader from "@/components/tables/CustomHeader.vue";
import CustomBody from "@/components/tables/CustomBody.vue";
import StatusBadge from "@/components/tables/commons/StatusBadge.vue";
import DocumentChips from "@/components/tables/commons/DocumentChips.vue";
import QuoteNumber from "@/components/tables/commons/QuoteNumber.vue";
library.add(faChevronLeft, faPlus, faChevronRight, faMoneyBillTransfer, faList, faFilePen, faFileLines, faFilePdf, faDownload);

export default {
  name: 'BusinessByClientTable',
  computed: {
    BUSINESS_STATUS_ENUM() {
      return BUSINESS_STATUS_ENUM
    }
  },
  components: {
    CustomBody,
    StatusBadge,
    DocumentChips,
    QuoteNumber,
    CustomHeader,
    CustomTable,
    BusinessManagementModal,
    AddBusinessModal,
  },
  data: function () {
    return {
      data: [],
      elements: [
        {label: "N°Devis", value: "number", type: "number"},
        {label: "N°Facture", value: "invoiceNumber", type: "number"},
        {label: "Titre", value: "title", type: "text"},
        {label: "Status", value: "status", type: "text", values: BUSINESS_STATUS_ENUM},
        {label: "Montant", value: "ttcAmount", type: "number"},
        {label: "Solde", value: "remaining", type: "number"},
        {label: "Actions", value: undefined, type: undefined}
      ],
    }
  },
  mounted() {
    this.$refs.table.$refs.searchArray.initWithURLParams();
    this.loadData();
  },
  methods: {
    showInvoice(business) {
      return !(!!business.invoiceNumber && [
        BusinessStatusEnum.READY_TO_SEND.value
      ].includes(business.status));
    },
    // Après création d'un devis : la modale du nouveau devis s'ouvre sans attendre le rechargement du tableau
    async openCreatedBusiness(businessId) {
      this.loadData();
      const business = await BusinessController.get(businessId);
      if (business && !business.errors) {
        this.$refs.businessManagementModal.openModal(business);
      }
    },
    async openBusiness(business) {
      if (!business.id) return;
      const fullBusiness = await BusinessController.get(business.id);
      if (fullBusiness && !fullBusiness.errors) {
        this.$refs.businessManagementModal.openModal(fullBusiness);
      }
    },
    async loadData() {
      this.$refs.table?.startLoading();
      this.data = [];
      const resp = await BusinessController.getAllForClient(this.$refs.table.buildURLParams());
      if (resp && !resp.errors) {
        for(let i=0; i < resp.length ;i++){
          this.data.push(resp[i]);
        }
      }
      this.$refs.table?.stopLoading();
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
@require '~/src/common/style/businessTable.styl';
.alert
  color #dc0000
  font-weight bold
.classic
  color auto
.warning
  color #d58900
  font-weight bold

.button-icon
  margin-right 10px
</style>